import { render, staticRenderFns } from "./ResultTrendBox.vue?vue&type=template&id=2d0acb70&scoped=true"
import script from "./ResultTrendBox.vue?vue&type=script&lang=js"
export * from "./ResultTrendBox.vue?vue&type=script&lang=js"
import style0 from "./ResultTrendBox.vue?vue&type=style&index=0&id=2d0acb70&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d0acb70",
  null
  
)

export default component.exports